import "./styles.css";
import Movies from "./components/common/Movies";
import NavBar from "./components/NavBar";
import { Route, Redirect, Switch } from "react-router-dom";
import Customers from "./components/Customers";
import Rentals from "./components/Rentals";
import NotFound from "./components/NotFound";
import MovieForm from "./components/MovieForm";
import Login from "./components/Login";
import RegisterForm from "./components/RegisterForm";
import MovieNew from "./components/MovieNew";

export default function App() {
  return (
    <>
      <NavBar />
      <div className="col-lg-8 mx-auto p-3 py-md-5">
        <Switch>
          <Route path="/movies/:new" component={MovieNew} />
          <Route path="/register" component={RegisterForm} />
          <Route path="/login" component={Login} />
          <Route path="/movies/:id" component={MovieForm} />
          <Route path="/movies" component={Movies} />
          <Route path="/customers" component={Customers} />
          <Route path="/rentals" component={Rentals} />
          <Route path="/not-found" component={NotFound} />
          <Redirect exact from="/" to="/movies" />
          <Redirect to="/not-found" />
        </Switch>
      </div>
    </>
  );
}
